import { AppBar, Button, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, Tooltip, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import LoadingBackdrop from '../../Common/LoadingBackdrop'
import { Add, Delete, Edit } from '@mui/icons-material'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom';
import { deleteRole, fetchAllRoles } from '../../../actions/rolesActions'
import Swal from 'sweetalert2'
import MainContentContainer from '../../MainContentContainer/MainContentContainer';

export default function RolesPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector(state => state.roles.loading);
  const roles = useSelector(state => state.roles.roles);

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = () => {
    dispatch(fetchAllRoles());
  }

  const handleEdit = (role) => {
    navigate(`/roles/${role.role_id}/edit`);
  }

  const handleDelete = (id) => {
    Swal.fire({
      title: `Are you sure?`,
      text: 'You will not be able to recover this role!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel'
    }).then((result) => {
      if (result.value) {
        dispatch(deleteRole(id));
      }
    });
  }

  return (
    <MainContentContainer>
      <LoadingBackdrop open={loading} />
      <AppBar position="sticky">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Role Management
          </Typography>
          <Button color="inherit" component={Link} to={`/roles/create`} startIcon={<Add />}>
            Add New Role
          </Button>
        </Toolbar>
      </AppBar>

      <TableContainer component={Paper} sx={{ marginTop: 3 }}>
        <Table aria-label="roles table">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell><strong>Role Name</strong></TableCell>
              <TableCell><strong>Description</strong></TableCell>
              <TableCell><strong>Admin Count</strong></TableCell>
              <TableCell><strong>Created Date</strong></TableCell>
              <TableCell align="right"><strong>Actions</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              roles.length > 0 ? (
                roles.map(role => (
                  <TableRow
                    key={role.role_id}
                  >
                    <TableCell>
                      <Typography variant="subtitle1">{role.role_name}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="subtitle1">{role.role_description}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="subtitle1">{role.admin_count}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="subtitle1">
                        {new Date(role.created_at).toLocaleDateString()}
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Tooltip title="Edit" placement="top">
                        <IconButton color="info" onClick={() => handleEdit(role)}>
                          <Edit />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete" placement="top">
                        <IconButton color="error" onClick={() => handleDelete(role.role_id)}>
                          <Delete />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              ) : null
            }
          </TableBody>
        </Table>
      </TableContainer>
    </MainContentContainer>
  )
} 